import { TREE } from "../../../utils/ServiceUtils";
import { ServiceBase } from "../ServiceBase";
import { GetNodeRequest } from "./reqeusts/GetNodeRequest";
import { NodeToPathRequest } from "./reqeusts/NodeToPathRequest";
import { GetNodeResponse } from "./responses/GetNodeResponse";
import { NodeToPathResponse } from "./responses/NodeToPathResponse";
import { ListNodeRequest } from "./reqeusts/ListNodeRequest";
import { ListNodeResponse } from "./responses/ListNodeResponse";
import { ListNodeByTypeRequest } from "./reqeusts/ListNodeByTypeRequest";
import { ListNodeByTypeResponse } from "./responses/ListNodeByTypeResponse";

export interface ITreeService {
    nodeToPath(request: NodeToPathRequest): Promise<NodeToPathResponse>;
    getNode(request: GetNodeRequest): Promise<GetNodeResponse>;
    listNode(request: ListNodeRequest): Promise<ListNodeResponse>;
    listNodeByType(request: ListNodeByTypeRequest): Promise<ListNodeByTypeResponse>;
}

export class TreeService extends ServiceBase implements ITreeService{
    public async nodeToPath(request: NodeToPathRequest): Promise<NodeToPathResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), TREE.nodeToPath, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(TREE.nodeToPath, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(TREE.nodeToPath, request.toXml());
        }

        var parsedResponse = super.sendResponse(response).NodeToPathResponse as NodeToPathResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;        
    }

    public async getNode(request: GetNodeRequest): Promise<GetNodeResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), TREE.getNode, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(TREE.getNode, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(TREE.getNode, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response).GetNodeResponse as GetNodeResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listNode(request: ListNodeRequest): Promise<ListNodeResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), TREE.listNode, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(TREE.listNode, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(TREE.listNode, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['NODE']).ListNodeResponse as ListNodeResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }

    public async listNodeByType(request: ListNodeByTypeRequest): Promise<ListNodeByTypeResponse> {
        let response: any = null;
        try {
            let tmp_response = (await this.makeCall(request.toXml(), TREE.listNodeByType, request.cancelSource));
            response = tmp_response.data;
            await this.updateCache(TREE.listNodeByType, request.toXml(), response);
        } catch (error: any) {
            response = await this.getFromCache(TREE.listNodeByType, request.toXml());
        }

        var parsedResponse = super.sendResponse2(response, ['NODE']).ListNodeByTypeResponse as ListNodeByTypeResponse;
        if(!super._checkErrors(parsedResponse)){

        };
        return parsedResponse;
    }
}